import { render, staticRenderFns } from "./ModalReceiveLog.vue?vue&type=template&id=01073730&scoped=true"
import script from "./ModalReceiveLog.vue?vue&type=script&lang=js"
export * from "./ModalReceiveLog.vue?vue&type=script&lang=js"
import style0 from "./ModalReceiveLog.vue?vue&type=style&index=0&id=01073730&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01073730",
  null
  
)

export default component.exports